export const actionTypes = {
  GET_ABROAD_REPRESENTATIVE_START: 'GET_ABROAD_REPRESENTATIVE_START',
  GET_ABROAD_REPRESENTATIVE_SUCCESS: 'GET_ABROAD_REPRESENTATIVE_SUCCESS',
  GET_ABROAD_REPRESENTATIVE_FINISH: 'GET_ABROAD_REPRESENTATIVE_FINISH',

  ADD_ABROAD_REPRESENTATIVE_START: 'ADD_ABROAD_REPRESENTATIVE_START',
  UPDATE_ABROAD_REPRESENTATIVE_START: 'UPDATE_ABROAD_REPRESENTATIVE_START',
  SAVE_ABROAD_REPRESENTATIVE_SUCCESS: 'SAVE_ABROAD_REPRESENTATIVE_SUCCESS',
  SAVE_ABROAD_REPRESENTATIVE_FINISH: 'SAVE_ABROAD_REPRESENTATIVE_FINISH',

  // delete / enable / disable share one flow: {abroadRepresentativeId: [{id}]}
  BULK_ABROAD_REPRESENTATIVE_START: 'BULK_ABROAD_REPRESENTATIVE_START',
  BULK_ABROAD_REPRESENTATIVE_SUCCESS: 'BULK_ABROAD_REPRESENTATIVE_SUCCESS',
  BULK_ABROAD_REPRESENTATIVE_FINISH: 'BULK_ABROAD_REPRESENTATIVE_FINISH',

  RESET_ABROAD_REPRESENTATIVE: 'RESET_ABROAD_REPRESENTATIVE',
}
